import React, { useEffect, useRef } from "react";
import { Vector as VectorLayer } from "ol/layer";
import { Vector as VectorSource } from "ol/source";
import { Style, Stroke } from "ol/style";
import { Feature } from "ol";
import MultiLineString from "ol/geom/MultiLineString";
import { useMap } from "./Context";

interface MarkerOverlayProps {
  multiLineCoordinates?: number[][][],
  width?: number,
  color?: string,
  onFeatureClick?: (coordinate: number[], feature: Feature) => void;
  featureClick?: boolean;
}

const StretchDisplay: React.FC<MarkerOverlayProps> = ({ multiLineCoordinates, width, color, onFeatureClick, featureClick }) => {

  const { map } = useMap();

  useEffect(() => {

    if (!map || !multiLineCoordinates) return;
    // Create a MultiLineString geometry
    const multiLineString = new MultiLineString(multiLineCoordinates);
    multiLineString.transform("EPSG:4326", "EPSG:3857"); // Transform if necessary

    // Create a Feature with styling
    const feature = new Feature(multiLineString);
    feature.setStyle(
      new Style({
        stroke: new Stroke({
          color,
          width,
        }),
      })
    );

    // Create a Vector Layer
    const vectorLayer = new VectorLayer({
      source: new VectorSource({
        features: [feature],
      }),
      zIndex: 9999,
    });

    // Click handler for vector features
    const clickHandler = (event: any) => {
      if (featureClick) {
        const pixel = map.getEventPixel(event.originalEvent);
        const clickedFeature = map.forEachFeatureAtPixel(pixel, (f: any) => f);

        if (clickedFeature === feature) { 
          // Zoom to the feature
          map.getView().fit(multiLineString.getExtent(), {
            padding: [50, 50, 50, 50],
            duration: 1000
          });

          if (onFeatureClick) {
            onFeatureClick(event.coordinate, feature);
          }
        }
      }
    };

    map.removeLayer(vectorLayer);
    map.on("click", clickHandler);
    map.addLayer(vectorLayer);
    // map
    return () => {
      map.un("click", clickHandler);
      map.removeLayer(vectorLayer);
    };

  }, [map, multiLineCoordinates, width, color, onFeatureClick]);

  return null;
};

export default StretchDisplay;
